import Component from '../abstracts/Component';
import vex from "vex-js";
// quick refactoring of privacyComponent
export default class NewPrivacyComponent extends Component {

  onB2Csignin() {
    $('body').on('change.bpr', 'input[name="param10"]', function (e) {
      $('.js-password-box').toggleClass('hidden');
    });
  }

  basicPrivacyAcceptance() {
    var _this = this;
    let isKr = (document.body.dataset.website === 'kr');

    // identifica il data enrichment enhanced utilizzato per le campagne di raccolta dati in cui non è possibile
    // impostare entrambi i flag di profilazione e marketing a false
    let isEnanched = false;
    if (typeof $('#enhancedData') !== 'undefined')
    {
      isEnanched = $('#enhancedData').attr('value') == 'true';
    }

    if (!isKr) {
      if (!$('input[id="basicPrivacy"], input[id="basicPrivacy-ft"], input[id="privacyNl_2"]').prop('checked')) {
        $('#registerForm').find('button[type="submit"]').attr("disabled", true);
      }

      $('body').on('click', 'input[name="newsletterProfiling"], input[name="newsletter"]', function (e) {
        _this.newsletterProfilingManagement();
      })

      $('body').on('change.bpr', 'input[id="basicPrivacy"], input[id="basicPrivacy-ft"], input[id="privacyNl_2"]', function (e) {
        e.stopImmediatePropagation();
        const $container = $(e.currentTarget).closest('form').find('.js-privacy-opts');
        const $form = $(e.currentTarget).closest('form');

        if ($(e.currentTarget).is(':checked')) {
          $container.removeClass('is-disabled');
          $container.find('input[type="radio"]').attr("disabled", false);
          // $container.find('#newsletterProfiling1').prop("checked", true);
          // $container.find('#newsletter1').prop("checked", true);
          if ($('[name=newsletterProfiling]').is(':checked') && $('[name=newsletter]').is(':checked')) {
            $form.find('button[type="submit"],button[type="button"]').attr("disabled", false);
          }
          if ($('[name="recalledBrandPrivacyData.profiled"]').is(':checked') && $('[name="recalledBrandPrivacyData.newsletter"]').is(':checked')) {
            $form.find('button[type="submit"]').attr("disabled", false);
          }
          if ($form.hasClass('js-contact-form')) {
            $form.find('button[type="submit"]').attr("disabled", false);
          }

        } else {
          $container.addClass('is-disabled');
          $container.find('input[type="radio"]').attr("disabled", true);
          $container.find('#newsletterProfiling1').prop("checked", false);
          $container.find('#newsletter1').prop("checked", false);
          $form.find('button[type="submit"]').attr("disabled", true);
        }
      });

      $('body').on('change.radioPrivacy', '[name="newsletterProfiling"], [name="newsletter"]', function (e) {
        e.stopImmediatePropagation();
        const $container = $(e.currentTarget).closest('form').find('.js-privacy-opts');
        const $form = $(e.currentTarget).closest('form');

        if ($('[name=newsletterProfiling]').is(':checked') && $('[name=newsletter]').is(':checked')) {
          $form.find('button[type="submit"]').attr("disabled", false);
        }

        if (isEnanched) {
          if ($("#newsletterProfiling1").is(':checked') || $("#newsletter1").is(':checked')) {
            // almeno uno tra profilazione e marketing a true
            $form.find('button[type="submit"]').attr("disabled", false);
          } else {
            $form.find('button[type="submit"]').attr("disabled", true);
          }
        }
      });

      $('body').on('change.radioPrivacyRecall', '[name="recalledBrandPrivacyData.profiled"], [name="recalledBrandPrivacyData.newsletter"]', function (e) {
        e.stopImmediatePropagation();
        const $container = $(e.currentTarget).closest('form').find('.js-privacy-opts');
        const $form = $(e.currentTarget).closest('form');

        if ($('[name="recalledBrandPrivacyData.profiled"]').is(':checked') && $('[name="recalledBrandPrivacyData.newsletter"]').is(':checked')) {
          $form.find('button[type="submit"]').attr("disabled", false);
        }
      });

      this.$on('click', this.updatePreference, 'body', '.updatePrivacyButton', this);
    }
  }

  privacyChat() {
    $('body').on('change.radioPrivacyChat', 'input[id="privacy_livechat"]', function (e) {
      e.stopImmediatePropagation();
      if ($('#privacy_livechat').is(':checked')) {
        $('#chatForm button[type="submit"]').attr("disabled", false);
      } else {
        $('#chatForm button[type="submit"]').attr("disabled", true);
      }
    });
  }

  // recall privacy function
  // similar to older websites
  recallPrivacyConfirm() {
    let ctx = this;
    $('body').on('click', '.js-apply-recall-options', function (e) {
      let ctx = this;
      e.preventDefault();
      e.stopImmediatePropagation();
      let content = $('#privacy-usubscribe-modal').html();

      ctx.$emit(this.$customEvents.MODAL_EVENTS.show, {
        unsafeContent: content
      })

    })
  }

  getPage(url, showLoader = true) {

    const ajaxConf = {
      type: 'GET',
      url: url,
    };

    if (showLoader) ajaxConf.beforeSend = () => this.$emit(this.$customEvents.LOADER_EVENTS.show);

    return $.ajax(ajaxConf);
  }

  showPrivacyModal() {
    this.showPrivacyModal = $('body').data('showPrivacyModal');

    if (this.showPrivacyModal) {
      this.getPage('/action/ajax/modalprivacy')
        .then(res => {
          this.$emit(this.$customEvents.MODAL_EVENTS.show, {
            unsafeContent: res,
            modalClass: 'modal-privacy-recall vex-medium-width',
          });
        })
        .then(() => {
          $('.js-single-item').slick({
            draggable: false,
            arrows: false,
          });
          $('a[data-slide]').click(function (e) {
            e.preventDefault();
            let currentSlide = $(this).data('slide');
            $('.js-single-item').slick('slickGoTo', currentSlide - 1);
          });

          $('.js-wrapper-privacy-recall').on('change.privacyRecallModal', function (e) {
            e.stopImmediatePropagation();
            const $container = $(e.currentTarget).closest('.js-privacyRecallModal').find('.js-privacy-opts');
            const $form = $(e.currentTarget).closest('.js-privacyRecallModal');

            if ($(e.currentTarget).is(':checked')) {
              $container.removeClass('is-disabled');
              $container.find('input[type="radio"]').attr("disabled", false);
              if ($('[name=newsletterProfiling]').is(':checked') && $('[name=newsletter]').is(':checked')) {
                $form.find('.js-apply-recall-options-modal').attr("disabled", false);
              }
            } else {
              $container.addClass('is-disabled');
              $container.find('input[type="radio"]').attr("disabled", true);
              $container.find('#newsletterProfiling1').prop("checked", false);
              $container.find('#newsletter1').prop("checked", false);
              $form.find('.js-apply-recall-options-modal').attr("disabled", true);
            }
          });

          $('[name="newsletterProfiling"], [name="newsletter"]').on('change.radioPrivacyRecallModal', function (e) {
            e.stopImmediatePropagation();
            const $container = $(e.currentTarget).closest('.js-privacyRecallModal').find('.js-privacy-opts');
            const $form = $(e.currentTarget).closest('.js-privacyRecallModal');

            if ($('[name="newsletterProfiling"]').is(':checked') && $('[name="newsletter"]').is(':checked')) {
              $form.find('.js-apply-recall-options-modal').attr("disabled", false);
            }
          });
          this.recallPrivacyStep2();
        });
    }
  }

  recallPrivacyStep2() {
    $('body').on('click.recallPrivacyStep2', '.js-apply-recall-options-modal', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      let newsletterProfiling = $('#newsletterProfiling1').prop('checked') ? true : false;
      let newsletter = $('#newsletter1').prop('checked') ? true : false;

      console.log('newsletterProfiling', newsletterProfiling);
      console.log('newsletter', newsletter);

      if (newsletterProfiling || newsletter) {
        ///update privacy
        let currentNewsletterProfiling = $('[name="currentNewsletterProfiling"]').attr('value');
        let currentNewsletter = $('[name="currentNewsletter"]').attr('value');
        let href = $(this).data('href');

        $.ajax({
          url: href,
          type: 'POST',
          data: {
            'new-form-privacy': true,
            currentNewsletterProfiling: currentNewsletterProfiling,
            currentNewsletter: currentNewsletter,
            newsletterProfiling: newsletterProfiling,
            newsletter: newsletter,
            privacy: true
          },
          dataType: "html"
        }).done(function (resp) {
          console.log(resp);
          let respJson = JSON.parse(resp);

          $('.vex-close').trigger('click');
          if (resp == '{}') {
            $('.js-recall-privacy-message').removeClass("hidden");
          } else {
            $('.js-recall-privacy-message-error').removeClass("hidden");
          }

        }).fail(function (xhr) {
          console.log(xhr);
        });

      } else {
        // delete
        let slideno = 3;
        $('.js-single-item').slick('slickGoTo', slideno - 1);
      }

    })

    $('body').on('click', '.js-delete-recall', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      let newsletterProfiling = $('#newsletterProfiling1').prop('checked') ? true : false;
      let newsletter = $('#newsletter1').prop('checked') ? true : false;
      let currentNewsletterProfiling = $('[name="currentNewsletterProfiling"]').attr('value');
      let currentNewsletter = $('[name="currentNewsletter"]').attr('value');
      let href = $(this).data('href');

      if (!newsletterProfiling && !newsletter) {
        $("<input type='hidden' name='delete-profile' value='delete-profile'/>").appendTo('#updatePrivacyForm');
      }

      $.ajax({
        url: href,
        type: 'POST',
        data: {
          'new-form-privacy': true,
          currentNewsletterProfiling: currentNewsletterProfiling,
          currentNewsletter: currentNewsletter,
          newsletterProfiling: newsletterProfiling,
          newsletter: newsletter,
          privacy: true
        },
        dataType: "html"
      }).done(function (resp) {
        window.location.href = "/register?deleteUser=true";
        $('.success-deletion').removeClass("hidden");
      }).fail(function (xhr) {
        console.log(xhr);
      });

    });
  }

  updatePreference(e) {
    e.event.preventDefault();
    const ctx = e.event.data;
    let $this = $(e.event.currentTarget);

    const $form = $this.closest('form');
    const currentNewsletterProfiling = $form.find("[name='currentNewsletterProfiling']").val();
    const currentNewsletter = $form.find("[name='currentNewsletter']").val();

    const newsletterProfiling = $form.find("[name='newsletterProfiling']:checked").val();
    const newsletter = $form.find("[name='newsletter']:checked").val();
    const privacy = $form.find(".js-register-privacy").is(':checked');

    $.ajax({
      url: $this.data('href'),
      type: 'POST',
      data: {
        'new-form-privacy': true,
        currentNewsletterProfiling: currentNewsletterProfiling,
        currentNewsletter: currentNewsletter,
        newsletterProfiling: newsletterProfiling,
        newsletter: newsletter,
        privacy: privacy
      },
    }).done(function (resp) {
      $('.alert-success').removeClass("hidden");
      $('.container-privacy').addClass('hidden');
    }).fail(function (xhr) {
      console.log(xhr);
    });
  }

  newsletterProfilingManagement() {
    if ($("#newsletterProfiling1").is(':checked') || $("#newsletter1").is(':checked')) {
      $('.js-newsletter-profiling').attr("disabled", false);
    } else {
      $('.js-newsletter-profiling').attr("disabled", true);
      $('.js-newsletter-profiling').each(function () {
        $(this).prop("checked", false);
      });
    }
  }

  onInputChange(){
    $('input[type="radio"], input[name="param7"]').on('input', function () {
      // now triggers at every 'onkeyup' to handle date insertion without confirm
      // Check if all input elements have values
      const genericDataForm = $('#genericData');
      const genericDataAsArray = $('#genericData').serializeArray();
      try{
        var regex = /^\d{2}[-]\d{2}[-]\d{4}$/;//xx-xx-xxxx
        //param7 input is updated only if the user entered a valid date.
        //datePickerEl has ALWAYS the current -formatted- date entered by the user
        var datePickerEl = genericDataForm.find('.js-datepicker.custom-date')[0];
        var param7 = genericDataAsArray.find(gd => gd.name === 'param7');
        var profiled = genericDataAsArray.find(gd => gd.name === 'profiled');
        if(datePickerEl == undefined || datePickerEl.hidden){
          if (profiled !== undefined && profiled.value.length > 0) {
            $("#btn-submit-profiling").prop("disabled", false);
          } else {
            $("#btn-submit-profiling").prop("disabled", true);
          }
        } else {
          if (regex.test(datePickerEl.value) //if entered date is incomplete (ex: dd-mm-yyy or dd-m-yyyy) disable the button
          &&  param7 !== undefined && param7.value.length > 0
          &&  profiled !== undefined && profiled.value.length > 0) {
            $("#btn-submit-profiling").prop("disabled", false);
          } else {
            $("#btn-submit-profiling").prop("disabled", true);
          }
        }
      }catch(e){
        console.error(e)
        $('#btn-submit-profiling').prop('disabled', true);
      }
    });
  }

  isPrivacyPage(){
    if ($("body").hasClass("t-privacy")) {
      return true;
    }
    return false;
  }

  render() {
    super.render();
    this.basicPrivacyAcceptance();
    this.newsletterProfilingManagement();
    this.privacyChat();
    this.onB2Csignin();
    this.showPrivacyModal();
    if (this.isPrivacyPage()) {
      this.onInputChange();
    }
  }
}
